import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import styled from "styled-components"
import { showModal, showNestedModal } from "../../../features/modal/modalSlice"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import { useState } from "react"
import Button from "../../shared/button/Button"
import { setUpdatedItemPublishType, updateLoad } from "../../../features/updateLoad/updateLoadSlice"
import getGivenDatePlusHours from "../../../helper/date/getGivenDatePlusHours"
import getCurrentDatePlusHours from "../../../helper/date/getCurrentDatePlusHours"
import InputPhoneFormat from "../../shared/input/new/InputPhoneFormat"
import { toast } from "react-toastify"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 800px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 30px 20px 30px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: ${({theme}) => theme.mainTextColor};
        .time-select{
            width: 100%;
            display: flex;
            margin-top: 10px;
            flex-direction: column;
            gap: 10px;
            .time-title{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-md);
            }
        }
        .project{
            margin-bottom: 30px;
            display: flex;
            flex-direction: column;
            gap: 10px;
            align-items: center;
        }

        p{
            font-size: var(--font-size-lg);
            font-weight: var(--font-weight-lg);
            margin-bottom: 10px;
        }

        .option-list{
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 25px;
            margin-bottom: 20px;
            width: 60%;

            .option-container{
                display: flex;
                flex-direction: column;
                align-items: center;
                width: 100%;
                .selected-item{
                    display: flex;
                    flex-direction: column;
                }
                .load-phone{
                    margin-top: 5px;
                    p{
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-md);
                        margin-bottom: 15px;
                    }
                }

                .option{
                    display: flex;
                    align-items: center;
                    width: 100%;
                    color: ${({theme}) => theme.mainTextColor};
                    
                    .option-btn{
                        background-color: ${({theme}) => theme.secondaryBgColor};
                        padding: 15px;
                        border-radius: 10px;
                        border: 2px solid transparent;
                        font-size: var(--font-size-md);
                        font-weight: var(--font-weight-md);
                        width: 100%;
                    }

                   
                    
                    .active{
                        border-color: var(--color-main);
                        color: var(--color-main);
                        background-color: ${({ theme }) => theme.mainBgColor};
                    }

                    .question-svg{
                        background-color: ${({theme}) => theme.secondaryBgColor};
                        width: 40px;
                        height: 35px;
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-weight: var(--font-weight-lg);
                        font-size: var(--font-size-lg);
                        cursor: pointer;
                        margin-right: 10px;
                    }

                }

                .desc{
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-md);
                        text-align: center;
                        line-height: 1.4;
                    }
        }
            
        }
         
    }
`

const yayinlamaSecenekleri = [
    {
        id:1,
        text: "Herkese Yayınla",
        description:"Tüm KAMYOON üyelerine yayınlanacaktır. Tüm üyeler teklif verebilecektir."
    },
    {
        id:2,
        text: "Önce Yük Arayan Araçlarıma - Sonra Herkese Yayınla",
        description:"Önce sürücülerime yayınlanacak; daha sonra tüm KAMYOON üyelerine yayınlanacaktır."
    },
    {
        id:3,
        text: "Yük Arayan Araçlarıma Yayınla",
        description:"Sadece kendi sürücülerime yayınlanacak ve sadece kendi sürücülerim teklif verebilecektir."
    },
    {
        id:4,
        text: "İş Listemde Kalsın",
        description:"Yayınlanmaz. Sadece kendi iş listenizde kalır. Teklif toplayamazsınız. “Herkese Yayınla” seçeneğini tercih etmeniz önerilir."
    }
]

const LoadUpdateYayinlamaSecenekleriModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()
    const { loadItemData } = useSelector(state => state.loadList)
    const { route, aracData, paymentData, yukData, paketlemeData, routeDistance, updatedItemPublishType, updatedItemPublishType2HourData} = useSelector(state => state.updateLoad)

    const [phone, setPhone] = useState("")

    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();
    
    const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
    const rld = JSON.parse(storage.getItem("rld"))

    //! buradaki publishTime ı updateLoad slice a alacaksın zaten orada ekledin bununla bağlayacaksın
    //! PublishingType2UpdateModal modalında da çağıracaksın, değiştirmesini yapcaksın
    //! şimdilik bu kadar gibi



    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()
        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    function convertDate(dateString) {
        const datePattern = /^\d{2}\.\d{2}\.\d{4}$/;
      
        if (!datePattern.test(dateString)) {
          return dateString; 
        }
      
        const [day, month, year] = dateString.split('.');
      
        return `${year}-${month}-${day}T03:00:00.000001`;
      }

    const handleClick = () => {

        const fixDecimalSeparator = (value) => {
            if (typeof value === 'string') {
                return value.replace(',', '.');
            }
            return value;
        };

        if((phone[2] !== "5" && phone.slice(2).length !== 10) && (updatedItemPublishType?.id === 1)){
            toast.error(`Lütfen Telefon Numarası giriniz.`, {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
        else{

              const data = {
                //! load
                    ...loadItemData,
                    isParsiyel: yukData?.yuklemeTuru.value,
                    loadtype: yukData?.yukTuru,
                    isDangerous: yukData?.yukADR,
                    dangerousDescription: yukData?.yukAdrDescription,
                    loadQuantity: yukData?.agirlikBirim.value === 3 ? 1 : parseInt(yukData?.toplamAgirlik),
                    loadUnit: yukData?.agirlikBirim.text,
                    loadUnitId: yukData?.agirlikBirim.value,
                    loadBulk: parseInt(yukData?.toplamHacim)  || 0,
                    loadDescription: yukData?.yukDesc,
                    loadValue: parseInt(yukData?.yukunDegeri) || 0,
                    companyLoadNumber: yukData?.companyLoadNumber || "",
                    customsPlace: yukData?.customsPlace || "",
                    vesselDate: yukData?.vesselDate || null,
                    isFreeZone: Boolean(yukData?.isFreeZone),
                    isInsuranceRequested: false, 

                    truckQuantity: parseInt(aracData?.aracSayisi),
                    usedTruckQuantity: 0,
                    truckType: aracData.aracTypeName,
                    truckTypeId: aracData.aracTypeId,
                    trailerType: aracData.kasaTypeName,
                    trailerTypeId: aracData.kasaTypeId,
                    groundType: aracData.zeminType.text ? aracData.zeminType.text : "Farketmez",
                    groundTypeId: aracData.zeminType.value || 0,
                    truckDescription: aracData.digerOzellikler,

                    loadOwnerFreight: parseInt(paymentData.yukverenFiyat) || 0,
                    freightVisibility:  paymentData.fiyatYayinlansin,
                    freight: parseInt(paymentData.hedefNakliyefiyat)  || 0,
                    distance: parseInt(routeDistance)  || 0,
                    publishingTypeId: updatedItemPublishType?.id,
                    isActive: false,
                    isFavorite: false,
                    commissionPaymentId: paymentData.komisyonDurumu.value || 0, 
                    commissionPayment: paymentData.komisyonMiktari.value === 0 ? 0 : parseInt(paymentData.komisyonMiktari),
                    fuelPaymentId: paymentData.yakitDurumu.value || 0,
                    fuelPayment:  paymentData.yakitDurumu.value === 0 ? 0 : parseInt(paymentData.yakitOrani),
                    paymentType: paymentData.odemeSekli.text,
                    paymentTypeId: paymentData.odemeSekli.value,
                    paymentUnit: paymentData.fiyatlandirmaType.value,
                    otherPaymentDescription: paymentData.odemeSekliDigerAciklama,
                    scheduledPublishTimeHours: updatedItemPublishType?.id === 2 ? updatedItemPublishType2HourData : null,

                    //! yük telefonu
                    phoneNumber: (phone?.startsWith("+90") || phone?.startsWith("90")) ? phone?.slice(2) : phone,
                    
                //! route
                routePoints: route.map((item, i) => {
                    const convertedDate1 = convertDate(item.date);
                    const convertedDate2 = convertDate(item.dateEngec);
                    const routeLat = item?.locationData?.isGoogleAddressSelected
                        ? item?.locationData?.lat
                        : item?.locationData?.googleLat ?? item?.locationData?.lat;
                    const routeLng = item?.locationData?.isGoogleAddressSelected
                        ? item?.locationData?.lng
                        : item?.locationData?.googleLng ?? item?.locationData?.lng;
                    
                    return {
                        city: item.locationData.il,
                        town: item.locationData.ilce,
                        address: item.adres,
                        forDirections: item.adresTarif,
                        location: item.locationData.location,


                        googleAddress: item?.locationData?.googleLocation,
                        isGoogleAddressSelected: item?.locationData?.isGoogleAddressSelected,
                        // googleLat: item?.locationData?.googleLat,
                        // googleLng: item?.locationData?.googleLng,
                        googleLat: fixDecimalSeparator(item?.locationData?.googleLat),
                        googleLng: fixDecimalSeparator(item?.locationData?.googleLng),


                        //! burada order gelecek, addLoad slice a da eklenmeli
                        order: i+1,
                        loadOrUnload: item.locationType === "yukleme" ? 0 : 1, 
                        lat: String(routeLat ?? ""),
                        lng: String(routeLng ?? ""),
                        //! bu tarihleri date tipinde yapılacak
                        loadDate: convertedDate1,
                        lateLoadDate: convertedDate2 || convertedDate1,
                        loadTime: item.saatBaslangic,
                        lateLoadTime: item.saatBitis,
                        loadAllTime: item.saatAllTime,
                        isAddressSaved: item.adresKaydedilsinMi,
                        savedAddressName: item.adresBaslik,
                        loadMethods: item.sevkBicimleri.filter((item) => {
                            return item.status
                        }).map(item => {
                            return {name: item.name, methodId: item.id}
                        }),
                        companyName: item.companyName,
                        mailAddress: item.mailAddress,
                        routePointPersonName: item.routePointPersonName,
                        routePointPersonPhoneNumber: item.routePointPersonPhoneNumber,
                        smsVerification: item.smsVerification || false,
                        smsVerificationPhoneNumber: item.smsVerificationPhoneNumber
                    }
                }),

                packingingTypes: paketlemeData.map(item => {
                    return {
                        packagingUnitId: item.activePaketlemeTypeId,
                        olculers: item.list.map(item => {
                            return {
                                en: parseInt(item?.en || 0),
                                boy: parseInt(item?.boy || 0),
                                yukseklik: parseInt(item?.yukseklik || 0),
                                agirlik: parseInt(item?.agirlik || 0),
                                sayisi: parseInt(item?.sayisi || 0),
                                cap: parseInt(item?.cap || 0),
                            }
                        })
                    }
                })
            }
            
            dispatch(updateLoad(data))
        }



        // dispatch(showModal(null))

    }
    

  return (
    <Container onClick={()=> dispatch(showModal(null))}>
        <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            {(rld !== ("ee37e5e8-6aa5-46cd-b718-2dd45e4f0d84" || "3d3aaf05-3ce1-4bfe-95d4-6feae88b1228")) &&
                <>
                <p>Bir Yayınlama Seçeneği Seçin</p>
                <div className="option-list">
                    {
                        yayinlamaSecenekleri.map((item) => (
                            <div className="option-container">
                                <div className="option">
                                    <button className={item.id === updatedItemPublishType.id ? "option-btn active" : "option-btn"} onClick={() => {dispatch(setUpdatedItemPublishType(item)); item.id === 2 && dispatch(showNestedModal("publishingType2Update"))}}>{item.text}</button>
                                </div>
                                {
                                    item.id === updatedItemPublishType.id && 
                                    <div className="selected-item" style={{display: "flex", paddingTop: "5px"}}>
                                    {
                                        updatedItemPublishType?.id === 1 && 
                                        <div className="load-phone">
                                            <p>Yük için yazılı olan telefon numarası kullanılacaktır.</p>
                                            <InputPhoneFormat data={phone} setData={setPhone} name={"phone"} labelText={"Telefon Numarası"} inputWidth={"100%"} />
                                        </div>
                                    }
                                    {
                                        updatedItemPublishType?.id === 2 &&
                                        <div className="desc">{`Önce sürücülerime yayınlanacak; ${updatedItemPublishType2HourData ? `${getCurrentDatePlusHours(updatedItemPublishType2HourData)?.formattedDate} ${getCurrentDatePlusHours(updatedItemPublishType2HourData)?.formattedTime} tarihinde` : loadItemData?.scheduledPublishTime ? `${getGivenDatePlusHours(3, loadItemData?.scheduledPublishTime?.slice(0, -1))?.formattedDate} ${getGivenDatePlusHours(3, loadItemData?.scheduledPublishTime?.slice(0, -1))?.formattedTime} tarihinde` : "daha sonra"} tüm KAMYOON üyelerine yayınlanacaktır.`}</div>
                                    }
                                    </div>
                                }
                                
                            </div>
                        ))
                    }
                    
                </div>
                </>
            }
            
            <Button handleClick={handleClick} text={"Yükü Güncelle"} width="60%" background={"#E85446"}  />
        </div>
    </Container>
  )
}

export default LoadUpdateYayinlamaSecenekleriModal
